/**
 * 影子跟读主页面 - 素材列表
 */
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ShadowMaterial, getAllMaterials, deleteMaterial } from '../../../db/shadowDb';
import { MaterialCard } from '../components/MaterialCard';
import { MaterialUpload } from '../components/MaterialUpload';
import '../styles/shadowReading.css';

export function ShadowReadingPage() {
  const navigate = useNavigate();
  const [materials, setMaterials] = useState<ShadowMaterial[]>([]);
  const [loading, setLoading] = useState(true);
  const [showUpload, setShowUpload] = useState(false);

  // 加载素材列表
  const loadMaterials = useCallback(async () => {
    try {
      const list = await getAllMaterials();
      setMaterials(list);
    } catch (err) {
      console.error('Failed to load materials:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadMaterials();
  }, [loadMaterials]);

  // 开始练习
  const handlePractice = useCallback((id: string) => {
    navigate(`/speaking/shadow/${id}`);
  }, [navigate]);

  // 进入 Retelling
  const handleRetelling = useCallback((id: string) => {
    navigate(`/speaking/shadow/${id}/retelling`);
  }, [navigate]);

  // 删除素材
  const handleDelete = useCallback(async (id: string) => {
    if (!window.confirm('确定要删除这个素材吗？所有练习记录将被清除。')) {
      return;
    }
    try {
      await deleteMaterial(id);
      setMaterials((prev) => prev.filter((m) => m.id !== id));
    } catch (err) {
      console.error('Failed to delete material:', err);
    }
  }, []);

  // 上传完成
  const handleUploadComplete = useCallback((materialId: string) => {
    setShowUpload(false);
    loadMaterials();
    // 可选：直接跳转到练习页
    // navigate(`/speaking/shadow/${materialId}`);
  }, [loadMaterials]);

  // 返回
  const handleBack = useCallback(() => {
    navigate('/today');
  }, [navigate]);

  if (loading) {
    return (
      <div className="shadow-page">
        <div className="shadow-loading">
          <div className="loading-spinner"><span></span></div>
          <p>加载中...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="shadow-page">
      {/* 头部 */}
      <div className="shadow-header">
        <button type="button" className="back-btn" onClick={handleBack}>
          ←
        </button>
        <h2 className="page-title">SHADOW READING</h2>
      </div>

      {/* 上传弹窗 */}
      {showUpload && (
        <div className="upload-overlay">
          <MaterialUpload
            onUploadComplete={handleUploadComplete}
            onCancel={() => setShowUpload(false)}
          />
        </div>
      )}

      {/* 主内容 */}
      <div className="shadow-content">
        {/* 添加按钮 */}
        <button
          type="button"
          className="add-material-btn"
          onClick={() => setShowUpload(true)}
        >
          + 上传新素材
        </button>

        {/* 素材列表 */}
        {materials.length === 0 ? (
          <div className="empty-state">
            <p className="empty-text">还没有素材</p>
            <p className="empty-hint">上传视频和字幕开始影子跟读练习</p>
          </div>
        ) : (
          <div className="materials-list">
            {materials.map((material) => (
              <MaterialCard
                key={material.id}
                material={material}
                onPractice={handlePractice}
                onRetelling={handleRetelling}
                onDelete={handleDelete}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
